<template>
  <div id="line" class="line">
    <div class="line-box clear">
      <div
        v-for="(line, index) in lineList"
        :key="index"
        class="line-item-box clear"
      >
        <div v-for="(item, index) in line" :key="index" class="line-item">
          <div class="line-head">
            <img :src="item.headImg" alt="headImg" />
            <!-- <img
              src="https://picbed.qunarzz.com/f490e9ae9177d63c5b718dc36e5b02ef.png"
              class="line-anchor"
            /> -->
          </div>
          <div class="line-cont">
            <div class="v-line-desc text-overflow">
              {{ item.desc }}
            </div>
          </div>
          <span class="tag-img">{{ item.tag }}}</span>
          <div v-maidian="'line_' + index" class="line-btm clear">
            <div class="price">
              <span class="price-span">{{
                discount ? item.price * 0.8 : item.price
              }}</span>
              <mt-button @click="jumpToSight(item.linkId)" size="small"
                >预订</mt-button
              >
            </div>
          </div>
        </div>
        <!-- <div class="bg-line"></div> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['lineList'],
  data() {
    return {
      discount: false,
    };
  },
  methods: {
    jumpToSight(link) {
      location.href = link;
    },
    jump() {
      this.$router.push({
        path: 'volvoxc60',
      });
    },
    goLine() {
      let timer = setTimeout(() => {
        clearTimeout(timer);
        timer = 0;
        let t = document.querySelector('.line-tit').clientHeight;
        window.scrollTo(0, document.querySelector('#line').offsetTop + t);
      }, 600);
    },
  },
};
</script>
<style lang='less' scoped='true'>
.line {
  position: relative;
  &-tit {
    width: 100%;
    .package {
      margin-left: 11px;
      margin-right: 11px;
      width: calc(100% - 22px);
      padding-top: 20px;
    }
  }
}
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.text-overflow {
  -webkit-line-clamp: 3;
}
.tag-img {
  width: 100%;
  display: block;
  margin-left: 8px;
  font-size: 11px;
  text-align: left;
}
.line {
  position: relative;
  .v-line-desc {
    font-weight: bold;
    text-align: left;
    padding-left: 8px;
    font-size: 13px;
    margin-bottom: 10px;
    margin-top: 6px;
  }
  &-box {
    padding-left: 21px;
    padding-right: 21px;
    margin-top: 10px;
  }
  &-item {
    overflow: hidden;
    position: relative;
    border-radius: 4px;
    width: 163px;
    background-color: #fff;
    margin-bottom: 15px;
    float: left;
    z-index: 2;
    &-box {
      position: relative;
      .bg-line {
        background: url(https://picbed.qunarzz.com/f85c6e94de1f40c4bae5c5a5c7261be5.png)
          no-repeat;
        background-size: 100% auto;
        height: 20px;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 7px;
      }
    }
    &:nth-child(2n + 2) {
      float: right;
    }
  }
  &-desc {
    height: 32px;
    font-size: 14px;
    line-height: 16px;
    margin-bottom: 5px;
    text-align: left;
    font-weight: bold;
  }
  &-tag {
    padding-left: 2px;
    padding-right: 2px;
    padding-top: 3px;
    padding-bottom: 3px;
    border: 0.1em solid #ff414c;
    border-radius: 2px;
    color: #ff414c;
    font-size: 9px;
    float: left;
    margin-right: 5px;
  }
  &-head {
    position: relative;
  }
  &-cont {
    padding: 4px;
  }
  &-btm {
    padding: 7px;
    .price {
      &-span {
        height: 19px;
        line-height: 19px;
        text-align: left;
        font-size: 18px;
        float: left;
        font-weight: bold;
        color: #ff2f00;
        &.discount {
          color: #aaa9a9;
        }
        position: relative;
        &:before {
          content: '￥';
          font-size: 9px;
          position: relative;
          font-weight: normal;
        }
        &:after {
          content: '起';
          font-size: 9px;
          font-weight: normal;
          position: relative;
        }
      }
      button {
        position: relative;
        float: right;
      }
    }
  }
  &-head {
    img {
      display: block;
      height: 89px;
      width: 100%;
    }
  }
  /deep/ .mint-button--small {
    border-radius: 0;
    background: linear-gradient(-54deg, #ffaf61 0%, #f719a1 100%);
    border-radius: 6px;
    color: #fff;
    font-size: 11px;
    height: 24px;
    margin-left: auto;
    margin-right: auto;
  }
  .line-anchor {
    position: absolute;
    left: 0;
    top: 0;
    height: 18px;
    color: #fff;
    font-style: italic;
    text-align: center;
    letter-spacing: 3px;
    border-radius: 3px 0px 3px 0px;
  }
}
</style>